import { render } from "./Preferences.vue?vue&type=template&id=f0bab8b4&ts=true"
import script from "./Preferences.vue?vue&type=script&lang=ts"
export * from "./Preferences.vue?vue&type=script&lang=ts"

import "./Preferences.vue?vue&type=style&index=0&id=f0bab8b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__